import { NgModule } from '@angular/core';
import { DeviceVinConfigPageRoutingModule } from './device-vin-config-routing';

@NgModule({
  imports: [DeviceVinConfigPageRoutingModule],
})
export class DeviceVinConfigPageModule {}
